module.exports = __webpack_public_path__ + "images/redeem-zaggle-e8b8ac6f75a1027966f028698f280334.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/redeem-zaggle.png
// module id = ./client/assets/images/redeem-zaggle.png
// module chunks = 86